
define('template!salesInboxStatsTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="stats-head">\n  <span class="stats-live"></span>\n  <span class="stats-title">Sales inbox</span>\n  <span class="stats-sub">Pulse</span>\n  <span class="stats-spacer"></span>\n  ';
 if (userOptions && userOptions.length) { ;
__p += '\n    <select class="user-picker" aria-label="Scope stats to a user">\n      <option value="">All users</option>\n      ';
 _.each(userOptions, function (u) { ;
__p += '\n        <option value="' +
((__t = ( u.secId )) == null ? '' : __t) +
'" ' +
((__t = ( u.secId === selectedUserSecId ? "selected" : "" )) == null ? '' : __t) +
'>' +
((__t = ( u.name )) == null ? '' : __t) +
'</option>\n      ';
 }); ;
__p += '\n    </select>\n  ';
 } ;
__p += '\n  ';
 if (localeOptions && localeOptions.length) { ;
__p += '\n    <select class="locale-picker" aria-label="Scope stats to a locale">\n      <option value="">All locales</option>\n      ';
 _.each(localeOptions, function (l) { ;
__p += '\n        <option value="' +
((__t = ( l.code )) == null ? '' : __t) +
'" ' +
((__t = ( l.code === selectedLocale ? "selected" : "" )) == null ? '' : __t) +
'>' +
((__t = ( l.label )) == null ? '' : __t) +
'</option>\n      ';
 }); ;
__p += '\n    </select>\n  ';
 } ;
__p += '\n  <span class="range-toggle">\n    ';
 _.each(ranges, function (r) { ;
__p += '\n      <button type="button" class="range-btn ' +
((__t = ( r.on ? "on" : "" )) == null ? '' : __t) +
'" data-range="' +
((__t = ( r.key )) == null ? '' : __t) +
'">' +
((__t = ( r.label )) == null ? '' : __t) +
'</button>\n    ';
 }); ;
__p += '\n  </span>\n  <span class="range-custom ' +
((__t = ( customOn ? "on" : "" )) == null ? '' : __t) +
'">\n    <input type="datetime-local" class="dt-from" value="' +
((__t = ( dtFromVal )) == null ? '' : __t) +
'" aria-label="From date and time">\n    <span class="dt-sep">→</span>\n    <input type="datetime-local" class="dt-to" value="' +
((__t = ( dtToVal )) == null ? '' : __t) +
'" aria-label="To date and time">\n    <button type="button" class="dt-apply">Apply</button>\n  </span>\n</div>\n\n<div class="stats-body ' +
((__t = ( loading ? "is-loading" : "" )) == null ? '' : __t) +
'">\n\n  ' +
((__t = ( barometerHtml )) == null ? '' : __t) +
'\n\n  <div class="exposure">\n    <div class="exposure-head">\n      <div class="eyebrow">' +
((__t = ( hero.eyebrow )) == null ? '' : __t);
 if (scopedUserName) { ;
__p += ' <span class="scope-chip"><i class="mdi mdi-social-person"></i>' +
((__t = ( scopedUserName )) == null ? '' : __t) +
'</span>';
 } ;
__p += '</div>\n      <div class="exposure-num"><span class="n">' +
((__t = ( hero.num )) == null ? '' : __t) +
'</span><span class="u">' +
((__t = ( hero.unit )) == null ? '' : __t) +
'</span></div>\n    </div>\n    <div class="rail">\n      ';
 _.each(rail.segments, function (s) { if (s.w <= 0) return; ;
__p += '\n        <div class="rail-seg ' +
((__t = ( s.cls )) == null ? '' : __t) +
'" style="width:' +
((__t = ( s.w )) == null ? '' : __t) +
'%"><span>' +
((__t = ( s.label )) == null ? '' : __t) +
'</span></div>\n      ';
 }); ;
__p += '\n    </div>\n    <div class="rail-legend">\n      ';
 _.each(rail.legend, function (l) { ;
__p += '\n        <span class="leg ' +
((__t = ( l.cls )) == null ? '' : __t) +
'"><i></i>' +
((__t = ( l.label )) == null ? '' : __t) +
' · ' +
((__t = ( l.count )) == null ? '' : __t) +
' items</span>\n      ';
 }); ;
__p += '\n    </div>\n  </div>\n\n  <div class="tiles">\n    <div class="tile">\n      <div class="tile-label">Median 1st response</div>\n      <div class="tile-val">' +
((__t = ( tiles.median )) == null ? '' : __t) +
'</div>\n      ';
 if (tiles.medianDelta != null) { ;
__p += '\n        <div class="tile-sub ' +
((__t = ( tiles.medianDelta <= 0 ? "good" : "bad" )) == null ? '' : __t) +
'">' +
((__t = ( tiles.medianDelta <= 0 ? "▼" : "▲" )) == null ? '' : __t) +
' ' +
((__t = ( Math.abs(tiles.medianDelta) )) == null ? '' : __t) +
'm vs last week</div>\n      ';
 } ;
__p += '\n    </div>\n    <div class="tile">\n      <div class="tile-label">Resolved vs inflow</div>\n      <div class="tile-val">' +
((__t = ( tiles.resolvedToday )) == null ? '' : __t);
 if (tiles.inflowToday != null) { ;
__p += '<span class="muted"> / ' +
((__t = ( tiles.inflowToday )) == null ? '' : __t) +
' in</span>';
 } ;
__p += '</div>\n      ';
 if (tiles.backlogDelta != null) { ;
__p += '\n        <div class="tile-sub ' +
((__t = ( tiles.backlogDelta > 0 ? "bad" : "good" )) == null ? '' : __t) +
'">' +
((__t = ( tiles.backlogDelta > 0 ? "▲ backlog +" + tiles.backlogDelta : "▼ cleared " + Math.abs(tiles.backlogDelta) )) == null ? '' : __t) +
' today</div>\n      ';
 } ;
__p += '\n    </div>\n    <div class="tile gold">\n      <div class="tile-label">VIP &amp; big order open</div>\n      <div class="tile-val">' +
((__t = ( tiles.vipNum )) == null ? '' : __t);
 if (tiles.vipCount != null) { ;
__p += '<span class="vip">★ ' +
((__t = ( tiles.vipCount )) == null ? '' : __t) +
' VIP</span>';
 } ;
__p += '</div>\n      ';
 if (tiles.vipValue) { ;
__p += '<div class="tile-sub gold">' +
((__t = ( tiles.vipValue )) == null ? '' : __t) +
' in this tier</div>';
 } ;
__p += '\n    </div>\n  </div>\n\n  <div class="section">\n    <div class="section-head"><span class="section-label">Real-time channels</span><span class="section-note">resolved chats &amp; calls in range</span></div>\n    <div class="chan-grid">\n      ';
 _.each(channels, function (c) { ;
__p += '\n        <div class="chan-card">\n          <div class="chan-head">\n            <span class="chan-icon ' +
((__t = ( c.key )) == null ? '' : __t) +
'"><i class="mdi mdi-communication-' +
((__t = ( c.key === "chat" ? "chat" : "call" )) == null ? '' : __t) +
'"></i></span>\n            <span class="chan-name">' +
((__t = ( c.name )) == null ? '' : __t) +
'</span>\n            <span class="chan-spacer"></span>\n            <span class="chan-total">' +
((__t = ( c.resolved )) == null ? '' : __t) +
'</span><span class="chan-total-l">resolved</span>\n          </div>\n          <div class="chan-foot"><span>' +
((__t = ( c.secLabel )) == null ? '' : __t) +
' <b>' +
((__t = ( c.secVal )) == null ? '' : __t) +
'</b></span></div>\n        </div>\n      ';
 }); ;
__p += '\n    </div>\n  </div>\n\n  <div class="stats-cols">\n    <div class="col">\n      <div class="section-label">Where the value sits</div>\n      <div class="cat-list">\n        ';
 if (!cats.length) { ;
__p += '<div class="empty">No data</div>';
 } ;
__p += '\n        ';
 _.each(cats, function (c) { ;
__p += '\n          <div class="cat-row">\n            <div class="cat-head"><span class="cat-name"><i style="background:' +
((__t = ( c.color )) == null ? '' : __t) +
'"></i>' +
((__t = ( c.label )) == null ? '' : __t);
 if (c.count != null) { ;
__p += '<span class="cat-count"> · ' +
((__t = ( c.count )) == null ? '' : __t) +
'</span>';
 } ;
__p += '</span><span class="cat-val">' +
((__t = ( c.valueLabel )) == null ? '' : __t) +
'</span></div>\n            <div class="cat-bar"><div class="cat-fill" style="width:' +
((__t = ( c.w )) == null ? '' : __t) +
'%;background:' +
((__t = ( c.color )) == null ? '' : __t) +
'"></div></div>\n            ';
 if (c.cases && c.cases.length) { ;
__p += '\n              <div class="cat-cases">\n                ';
 _.each(c.cases, function (cc) { ;
__p += '\n                  <span class="case-chip">' +
((__t = ( cc.label )) == null ? '' : __t) +
' <b>' +
((__t = ( cc.count )) == null ? '' : __t) +
'</b></span>\n                ';
 }); ;
__p += '\n              </div>\n            ';
 } ;
__p += '\n          </div>\n        ';
 }); ;
__p += '\n      </div>\n    </div>\n    <div class="col">\n      <div class="section-label">Lifecycle</div>\n      <div class="funnel">\n        ';
 if (!lifecycle.length) { ;
__p += '<div class="empty">No data</div>';
 } ;
__p += '\n        ';
 _.each(lifecycle, function (l) { ;
__p += '\n          <div class="fn-row ' +
((__t = ( l.muted ? "muted" : "" )) == null ? '' : __t) +
'"><span class="fn-dot" style="background:' +
((__t = ( l.color )) == null ? '' : __t) +
'"></span><span class="fn-label">' +
((__t = ( l.label )) == null ? '' : __t) +
'</span><span class="fn-count">' +
((__t = ( l.count )) == null ? '' : __t) +
'</span></div>\n          <div class="fn-bar"><div class="fn-fill" style="width:' +
((__t = ( l.w )) == null ? '' : __t) +
'%;background:' +
((__t = ( l.color )) == null ? '' : __t) +
'"></div></div>\n        ';
 }); ;
__p += '\n      </div>\n    </div>\n  </div>\n\n  <div class="section">\n    <div class="section-label">Team pace</div>\n    <div class="team-table">\n      <div class="thead">\n        <span class="th-user th-sortable ' +
((__t = ( sort.field === 'user' ? 'on' : '' )) == null ? '' : __t) +
'" data-sort="user">User';
 if (sort.field === 'user') { ;
__p += '<i class="sort-ar">' +
((__t = ( sort.desc ? '▼' : '▲' )) == null ? '' : __t) +
'</i>';
 } ;
__p += '</span>\n        <span class="th-n th-sortable ' +
((__t = ( sort.field === 'open' ? 'on' : '' )) == null ? '' : __t) +
'" data-sort="open">Open';
 if (sort.field === 'open') { ;
__p += '<i class="sort-ar">' +
((__t = ( sort.desc ? '▼' : '▲' )) == null ? '' : __t) +
'</i>';
 } ;
__p += '</span>\n        <span class="th-n th-sortable ' +
((__t = ( sort.field === 'resolved' ? 'on' : '' )) == null ? '' : __t) +
'" data-sort="resolved">Resolved';
 if (sort.field === 'resolved') { ;
__p += '<i class="sort-ar">' +
((__t = ( sort.desc ? '▼' : '▲' )) == null ? '' : __t) +
'</i>';
 } ;
__p += '</span>\n        <span class="th-n th-sortable ' +
((__t = ( sort.field === 'resp' ? 'on' : '' )) == null ? '' : __t) +
'" data-sort="resp">1st resp.';
 if (sort.field === 'resp') { ;
__p += '<i class="sort-ar">' +
((__t = ( sort.desc ? '▼' : '▲' )) == null ? '' : __t) +
'</i>';
 } ;
__p += '</span>\n        <span class="th-ch th-sortable ' +
((__t = ( sort.field === 'chat' ? 'on' : '' )) == null ? '' : __t) +
'" data-sort="chat">Chat';
 if (sort.field === 'chat') { ;
__p += '<i class="sort-ar">' +
((__t = ( sort.desc ? '▼' : '▲' )) == null ? '' : __t) +
'</i>';
 } ;
__p += ' <em>resolved</em></span>\n        <span class="th-ch th-sortable ' +
((__t = ( sort.field === 'calls' ? 'on' : '' )) == null ? '' : __t) +
'" data-sort="calls">Calls';
 if (sort.field === 'calls') { ;
__p += '<i class="sort-ar">' +
((__t = ( sort.desc ? '▼' : '▲' )) == null ? '' : __t) +
'</i>';
 } ;
__p += ' <em>resolved</em></span>\n        <span class="th-n th-sortable ' +
((__t = ( sort.field === 'oldest' ? 'on' : '' )) == null ? '' : __t) +
'" data-sort="oldest">Oldest';
 if (sort.field === 'oldest') { ;
__p += '<i class="sort-ar">' +
((__t = ( sort.desc ? '▼' : '▲' )) == null ? '' : __t) +
'</i>';
 } ;
__p += '</span>\n      </div>\n      ';
 if (!users.length) { ;
__p += '<div class="empty">No data</div>';
 } ;
__p += '\n      ';
 _.each(users, function (u) { ;
__p += '\n        <div class="trow">\n          <span class="td-user">\n            ';
 if (u.unassigned) { ;
__p += '<span class="avatar empty">—</span>';
 } else { ;
__p += '<span class="avatar" style="background:' +
((__t = ( u.avatarColor )) == null ? '' : __t) +
'">' +
((__t = ( u.initials )) == null ? '' : __t) +
'</span>';
 } ;
__p += '\n            <span class="nm ' +
((__t = ( u.unassigned ? "muted" : "" )) == null ? '' : __t) +
'">' +
((__t = ( u.name )) == null ? '' : __t) +
'</span>\n          </span>\n          <span class="td-n ' +
((__t = ( u.unassigned && u.open ? "hot" : "" )) == null ? '' : __t) +
'">' +
((__t = ( u.open )) == null ? '' : __t) +
'</span>\n          <span class="td-n calm">' +
((__t = ( u.resolved )) == null ? '' : __t) +
'</span>\n          <span class="td-n">' +
((__t = ( u.median )) == null ? '' : __t) +
'</span>\n          <span class="td-ch"><b>' +
((__t = ( u.chatResolved != null ? u.chatResolved : "—" )) == null ? '' : __t) +
'</b></span>\n          <span class="td-ch"><b>' +
((__t = ( u.callsResolved != null ? u.callsResolved : "—" )) == null ? '' : __t) +
'</b></span>\n          <span class="td-n ' +
((__t = ( u.oldestHot ? "hot" : "cool" )) == null ? '' : __t) +
'">' +
((__t = ( u.oldest )) == null ? '' : __t) +
'</span>\n        </div>\n      ';
 }); ;
__p += '\n    </div>\n  </div>\n\n</div>\n';

}
return __p
};});

